document.addEventListener('click', function (e) {
  var trigger = e.target.closest('.m-video-popup-trigger');
  if (trigger) {
    var section = trigger.closest('section');
    var modal = section.querySelector('.m-video-popup');
    var embed = modal.querySelector('.m-video-popup__embed');
    var template = section.querySelector('#' + trigger.dataset.videoTarget);
    embed.innerHTML = '';
    if (template) embed.appendChild(template.content.cloneNode(true));
    modal.hidden = false;
    document.body.classList.add('m-video-popup-open');
    return;
  }
  if (e.target.closest('[data-video-popup-close]')) {
    var modal = e.target.closest('.m-video-popup');
    modal.hidden = true;
    modal.querySelector('.m-video-popup__embed').innerHTML = '';
    document.body.classList.remove('m-video-popup-open');
  }
});